import { render, staticRenderFns } from "./CabecalhoInterativo.vue?vue&type=template&id=4a63f0b7&"
import script from "./CabecalhoInterativo.vue?vue&type=script&lang=js&"
export * from "./CabecalhoInterativo.vue?vue&type=script&lang=js&"
import style0 from "./CabecalhoInterativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports